import { SearchState } from '../SearchStore';

export type ResultItem = {
  id: string;
  Component: React.ElementType;
  type?: string;
  props?: {
    [key: string]: any;
  };
  score?: number;
};

export enum MagicSearchPluginName {
  FuseSearchPlugin = 'fuseSearchPlugin',
  ToolSearchPlugin = 'toolSearchPlugin',
  ScopeSearchPlugin = 'scopeSearchPlugin',
  ReactQueryPlugin = 'reactQueryPlugin',
  RecentSearchesPlugin = 'recentSearchesPlugin',
}

type MagicSearchPluginBase = {
  name: MagicSearchPluginName;
  // The hint that will activate this plugin are the different text that the user can type to activate this plugin.
  // This trigger are going to be used to give the user a hint of what they can type to activate the plugins.
  // For example, the "scopeSearchPlugin" plugin is activated when the user types "in:project".
  hint?: (searchState: SearchState) => string | null;
  onLinkItemClick?: (searchState: SearchState) => void;
};

export type MagicSearchPluginSync = MagicSearchPluginBase & {
  onSearch: (searchState: SearchState) => ResultItem[];
};

export type MagicSearchPluginAsync = MagicSearchPluginBase & {
  onSearching: (searchState: SearchState) => ResultItem[];
  onSearch: (searchState: SearchState) => Promise<ResultItem[]>;
};

export type MagicSearchPlugin = MagicSearchPluginSync | MagicSearchPluginAsync;
